/**
 * Select selectedValues
 * @param conversionToolColumns - conversion tool embedded state slice
 * @returns {*|{}}
 */
export const selectedValuesSelector = ({
  conversionTool: { conversionToolColumns = {} } = {},
} = {}) => conversionToolColumns.model?.selectedValues || {};
